export enum FormInputTypes {
  textField,
  number,
  multilineTextField,
  textView,
  longTextView,
  textLinkView,
  titleAndValue,
  disabledTextField,
  password,
  select,
  customRenderSelect,
  yearMonthPicker,
  datePicker,
  multiDateTimePicker,
  multilineSelect,
  userEmailAutocomplete,
  accountNameAutocomplete,
  locationNameAutocomplete,
  image,
  switch,
  googleAddressAutocomplete,
  checkbox,
  miniTitle,
  component,
  filterListSelect,
  time,
  jsonView,
  editableJsonView,
  qrCode,
  multiAutocomplete,
  loader,
  pugCart,
  textFieldWithPrefix,
  datePresets,
  button,
  textButton,
  radioButton,
  horizontalRow,
  taskLogField,
  starRating,
  imageUpload,
  timeRange,
  checkboxSelect,
  selectRepeatInterval,
}

export const COUNTRIES = [
  'Albania',
  'Andorra',
  'Austria',
  'Belarus',
  'Belgium',
  'Bosnia and Herzegovina',
  'Bulgaria',
  'Croatia',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Estonia',
  'Finland',
  'France',
  'Germany',
  'Greece',
  'Hungary',
  'Iceland',
  'Ireland',
  'Italy',
  'Kosovo',
  'Latvia',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Malta',
  'Moldova',
  'Monaco',
  'Montenegro',
  'Netherlands',
  'North Macedonia',
  'Norway',
  'Poland',
  'Portugal',
  'Romania',
  'San Marino',
  'Serbia',
  'Slovakia',
  'Slovenia',
  'Spain',
  'Sweden',
  'Switzerland',
  'Turkey',
  'Ukraine',
  'United Kingdom',
];

export enum languageAbbreviations {
  English = 'en',
  Slovenščina = 'si',
}

export const standardDataGridProps: any = {
  disableColumnReorder: true,
  disableColumnSelector: true,
  disableSelectionOnClick: true,
  disableColumnMenu: true,
  autoHeight: true,
  pageSize: 20,
} as const;
